import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/less_than_black.svg'


const _withScopeId = n => (_pushScopeId("data-v-555172d1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-view-main-block" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = { class: "new-entry h5" }
const _hoisted_4 = { class: "component-block" }
const _hoisted_5 = { class: "time-entry-button-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_time_entry_exit_popup = _resolveComponent("time-entry-exit-popup")!
  const _component_flow_circle = _resolveComponent("flow-circle")!
  const _component_ta_button = _resolveComponent("ta-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.showWarning)
      ? (_openBlock(), _createBlock(_component_time_entry_exit_popup, {
          key: 0,
          onReturnToDashboard: _ctx.routeToDashboard,
          onClosePopup: _ctx.closeWarningPopup
        }, null, 8, ["onReturnToDashboard", "onClosePopup"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "back-button small-text-grey",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.leavePage()))
      }, [
        _hoisted_2,
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("component-new-task-view.back")), 1)
      ]),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("component-new-task-view.new-entry")), 1),
      _createVNode(_component_flow_circle, {
        ref: "flowCircle",
        circleMaxValue: _ctx.maxCircleValue,
        circleTextArray: _ctx.languageKeyArray,
        canProceed: _ctx.proceedCheck,
        onSelectedCircle: _ctx.showComponent
      }, null, 8, ["circleMaxValue", "circleTextArray", "canProceed", "onSelectedCircle"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_Transition, {
          name: "time-entry-animations",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.requireComponent), {
              onTaskSelected: _ctx.canProceedNext,
              onSelectedCircleWithEdit: _ctx.showComponent,
              onTagSelected: _ctx.canProceedNext,
              onDateAndTimeSelected: _ctx.canProceedNext
            }, null, 8, ["onTaskSelected", "onSelectedCircleWithEdit", "onTagSelected", "onDateAndTimeSelected"]))
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_ta_button, {
          class: "cancel-button-local",
          text: _ctx.cancelText,
          backgroundColor: 'gray-dark-text',
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.leavePage()))
        }, null, 8, ["text"]),
        _createVNode(_component_ta_button, {
          class: _normalizeClass(["next-button", {
            'next-button-disabled': _ctx.disableNextButton,
          }]),
          text: _ctx.nextText,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.next()))
        }, null, 8, ["class", "text"]),
        (_ctx.isCompletionPage() && !_ctx.editEnabled)
          ? (_openBlock(), _createBlock(_component_ta_button, {
              key: 0,
              class: _normalizeClass(["save-and-continue-button", {
            'save-and-continue-button-disabled': _ctx.disableNextButton,
          }]),
              text: _ctx.saveAndContinueText,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.saveAndContinue()))
            }, null, 8, ["class", "text"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}